import MapImage from '../../../assets/directions/Map.png';

import classes from './Directions.module.css';
import Button from "../../../components/button/Button";
import React from "react";
import {useHistory} from "react-router-dom";

const Directions = () => {

    const history = useHistory();

    return (
        <div className={classes.Container}>
            <div className={classes.Left}>
                <div className={classes.Section}>
                    <div className={classes.Header}>
                        Address
                    </div>
                    <div>
                        <a href="https://www.google.com/maps/place/7305+Linden+Ave+N,+Seattle,+WA+98103/@47.6819457,-122.3466064" target={'_blank'}>
                            7305 Linden Ave N,
                            Seattle, WA 98103
                        </a>
                    </div>
                </div>
                <div className={classes.Section}>
                    <div className={classes.Header}>
                        Directions
                    </div>
                    <div>
                        There is always street parking available!
                        <br />
                        <br />
                        Enter through the main door of the Off White beauty salon.
                    </div>
                </div>
                <Button className={classes.Button} onClick={() => history.push('/book')}>
                    Book now
                </Button>
            </div>
            <div className={classes.Right}>
                <a href="https://www.google.com/maps/place/7305+Linden+Ave+N,+Seattle,+WA+98103/@47.6819457,-122.3466064" target={'_blank'}>
                    <img src={MapImage} />
                </a>
            </div>
        </div>
    )
}

export default Directions;
